import { ENV_ENUM } from '@/core/http/env';

export * from './global';
export * from './system-info';

// 内部租户各环境指定id，处理特殊需求（【天工fashion业务部】这个客户）
export const specialTenantIdMap: Partial<Record<ENV_ENUM, string>> = {
  // 开发环境
  [ENV_ENUM.DEV]: '7136307082579410952',
  // 测试环境
  [ENV_ENUM.QA]: '7092999830523404586',
  // 预发布环境
  [ENV_ENUM.UAT]: '7095970463934877704',
  // 生产环境
  [ENV_ENUM.PROD]: '7096028877830541371',
};

// export enum CUSTOM_DOMAIN_SYSTEM_ENUM {
//   FASHION_PHOTO_API = 'tgFashionPhotoApi',
//   /** FashionMindApi */
//   FASHION_MIND_API = 'tgFashionMindApi',
//   /** tgFashionDesignApi */
//   FASHION_DESIGN_API = 'tgFashionDesignApi',
// }
